import { PlusOutlined } from "@ant-design/icons";
import { Modal, Button, Input, Form } from "antd";
import TagNumber from "../TagNumber";
import { useForm } from "antd/es/form/Form";
import { FormInstance, FormProps } from "antd/lib";
import { useEffect, useRef, useState } from "react";
import '../NotificationFeesSetting.scss';
import { addNotificationCosts } from "../../../api/network/networkApi";
import { normalizeNumberInput, validatePositiveNumberMax12 } from "../../../until";

interface Props {
  isOpen: boolean
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}

const ModalAddEmail: React.FC<Props> = ({
  isOpen,
  onSubmitFormModal, closeModal
}) => {
  const [form] = useForm();
  const formRef = useRef<FormInstance<any>>(null);

  const [uploadedFile, setUploadedFile] = useState<File>()



  const handleFileChange = (event: any) => {
    const file = event.target.files?.[0] || null;
    setUploadedFile(file);
  };

  const handleUploadClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };


  const onFinish: FormProps["onFinish"] = async (values) => {
    const {
      tenEmail, soLuong, chiPhi,
    } = values;

    const result = await addNotificationCosts(
      Number(chiPhi?.replaceAll(".", "")), 3, uploadedFile, tenEmail, undefined, undefined, undefined
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result.message)
    } else {
      onSubmitFormModal?.(false, result.message)
    }
  };

  useEffect(() => {
    if (isOpen) {

    } else {
      setUploadedFile(undefined)
      form.resetFields()
    }

  }, [isOpen])

  return (
    <Form
      form={form}
      ref={formRef}
      name="basic"
      autoComplete="off"
      className="rs-form voucher-update-form"
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title="Thêm nhà cung cấp"
        open={isOpen}
        centered
        footer={
          [
            <span
              key="back"
              className="neutral-gray-400 cursor-pointer"
            >Làm mới thông tin</span>,

            <Button
              key="submit"
              type="primary"
              onClick={submitForm}
              className="rs-button"
            >
              Lưu
            </Button>,
          ]}
        className="rs-modal w-400"
        onCancel={closeModal}
      >
        <div className="d-flex flex-column gap-18-px">
          <div className="border-F2F4F7 rounded-2-px w-104-px h-104-px bg-F9FAFB d-flex align-center justify-center relative">
            {
              uploadedFile ? (
                <div >
                  <Form.Item
                    name="img1"
                    rules={[

                    ]}
                    className="m-none-form-item text-explan "
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                  </Form.Item>
                  <img src={uploadedFile ? URL.createObjectURL(uploadedFile) : undefined} alt="Uploaded" className="w-104-px h-104-px rounded-3 cursor-pointer" onClick={handleUploadClick} />
                </div>
              ) : (
                <div >
                  <Form.Item
                    name="img2"
                    rules={[
                      { required: true, message: 'vui lòng chọn ảnh!' },
                    ]}
                    className="m-none-form-item text-explan absolute bottom_-22-px w-109-px left-0"
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                  </Form.Item>
                  <div
                    className="d-flex flex-column align-center gap-2 cursor-pointer"
                    onClick={handleUploadClick}
                  >
                    <PlusOutlined className="text-sm text-252626" />
                    <span className="text-sm text-98A2B3 text-center">Tải lên <br /> Hình ảnh</span>
                  </div>
                </div>
              )}
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Tên email</p>
            <Form.Item
              name="tenEmail"
              rules={[{ required: true, message: 'Vui lòng nhập tên email!' }]}
            >
              <Input
                placeholder="Tên email"
                className="rs-input rs-input--32"
              />
            </Form.Item>
          </div>

          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Số lượng email</p>
            <Form.Item
              name="soLuong"
              validateTrigger="onChange"
              getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
              rules={[
                {
                  validator: validatePositiveNumberMax12,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const orderValueMin = getFieldValue('orderValueMin');

                    if (!value || !orderValueMin) {
                      return Promise.resolve();
                    }

                    const reducedAmountRaw = String(value).replace(/\./g, '');
                    const orderValueMinRaw = String(orderValueMin).replace(/\./g, '');

                    if (!/^\d+$/.test(reducedAmountRaw) || !/^\d+$/.test(orderValueMinRaw)) {
                      return Promise.resolve();
                    }

                    const reducedAmountNumber = Number(reducedAmountRaw);
                    const orderValueMinNumber = Number(orderValueMinRaw);

                    if (reducedAmountNumber > orderValueMinNumber) {
                      return Promise.reject(
                        new Error(
                          `Số tiền giảm tối đa (${reducedAmountNumber.toLocaleString(
                            'vi-VN'
                          )}) không được lớn hơn giá trị đơn hàng tối thiểu (${orderValueMinNumber.toLocaleString(
                            'vi-VN'
                          )})!`
                        )
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                placeholder="Số lượng email cho 1 lần gửi"
                className="rs-input rs-input--32"
                inputMode="numeric"
              />
            </Form.Item>
          </div> */}

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Chi phí </p>
            <Form.Item
              name="chiPhi"
              validateTrigger="onChange"
              getValueFromEvent={(e) => normalizeNumberInput(e.target.value)}
              rules={[
                {
                  validator: validatePositiveNumberMax12,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const orderValueMin = getFieldValue('orderValueMin');

                    if (!value || !orderValueMin) {
                      return Promise.resolve();
                    }

                    const reducedAmountRaw = String(value).replace(/\./g, '');
                    const orderValueMinRaw = String(orderValueMin).replace(/\./g, '');

                    if (!/^\d+$/.test(reducedAmountRaw) || !/^\d+$/.test(orderValueMinRaw)) {
                      return Promise.resolve();
                    }

                    const reducedAmountNumber = Number(reducedAmountRaw);
                    const orderValueMinNumber = Number(orderValueMinRaw);

                    if (reducedAmountNumber > orderValueMinNumber) {
                      return Promise.reject(
                        new Error(
                          `Số tiền giảm tối đa (${reducedAmountNumber.toLocaleString(
                            'vi-VN'
                          )}) không được lớn hơn giá trị đơn hàng tối thiểu (${orderValueMinNumber.toLocaleString(
                            'vi-VN'
                          )})!`
                        )
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                placeholder="Chi phí / 1 tin (đ)"
                className="rs-input rs-input--32"
                inputMode="numeric"
              />
            </Form.Item>
          </div>

        </div>


      </Modal >
    </Form>
  )
}
export default ModalAddEmail
